---
title: Limewash Cottage
year: 2024
typology: residential
location: Indialantic, FL
summary: A 1,400-sq-ft beach cottage rebuilt around its original heart-pine floors. A small project on a small lot, made to feel inevitable.
heroImage: /projects/limewash-cottage/hero.svg
heroAlt: A small beach cottage living room with heart-pine floors, limewash walls, and a single rattan armchair beside a window.
materials:
  - Heart-pine flooring (original, restored)
  - Limewash plaster
  - Cane and rattan
  - Antique linen
gallery:
  - src: /projects/limewash-cottage/gallery/01.svg
    alt: Hand-sanded heart-pine floor catching morning light.
    caption: The original heart-pine, sanded by hand. The reason the project exists.
  - src: /projects/limewash-cottage/gallery/02.svg
    alt: Casement window with afternoon light pooling on the floor.
    caption: The casement window — kept original, refurbished. The light it draws is the room's other furniture.
  - src: /projects/limewash-cottage/gallery/03.svg
    alt: Rattan armchair with an antique linen cushion against a limewash wall.
    caption: One chair, one cushion. The whole composition.
  - src: /projects/limewash-cottage/gallery/04.svg
    alt: Bronze sconce on a deep textured limewash plaster wall.
    caption: Light is held to a single sconce. Two switches in the whole room — light placement is architecture.
  - src: /projects/limewash-cottage/gallery/05.svg
    alt: A single bronze sconce washing a textured limewash wall with warm light.
    caption: Evening — one sconce, one cushion, three blocks from the beach. Inevitable.
placeholder: true
---

The most disciplined project we have completed. A 1,400-square-foot cottage three blocks from the beach, on a lot too small for anything ambitious.

The original heart-pine floors had been buried under three layers of vinyl and one layer of carpet. We pulled it all up and sanded by hand. Everything else was built around them.

## What we kept

The floors. The original casement windows. The footprint.

## What we changed

Removed two interior walls to open the living-dining-kitchen into one continuous room. Replastered everything in limewash. Specified a single rattan armchair, an antique linen sofa, a small cane drinks table, a bronze sconce.

That's the whole interior.

*Project complete. Photography forthcoming.*
